export default __webpack_public_path__ + "static/media/mediexcel_logo_white.4a416cfa.png";